import {Component, Input} from '@angular/core';
import {BaseView} from '../../../../../core/view/base.view';
import {PartnerSummaryModel, PartnerType} from '../../model/partnerSummary.model';
import {PartnerCommandService} from "../../command/partnerCommand.service";
import {TablerIconsProvider} from "angular-tabler-icons";
import {IconUserCircle} from "angular-tabler-icons/icons";

@Component({
    selector: 'app-partner-summary-field',
    templateUrl: './partner-summary-field.component.html',
    providers: [
        TablerIconsProvider.pick({IconUserCircle})
    ]
})
export class PartnerSummaryFieldComponent extends BaseView {

    @Input() partnerSummary: PartnerSummaryModel;
    @Input() label: string;
    constructor(public partnerCommandService: PartnerCommandService) {
        super();
    }


    redirectToPartner() {
        this.redirectToFromCommandAction(this.partnerCommandService.partnerHome(this.partnerSummary));
    }

}
